module.exports = __webpack_public_path__ + "static/media/cq_aggiorna_dati b.d3e2bacd.svg";